import { FetchResult, gql } from 'apollo-boost';
import { IUserPlan } from '../../../models/user-plan';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation UserPlanSave($userPlan: UserPlanSaveInput!){
        user_plan_save (input_data: $userPlan) {
            uid
        }
    }
`;

export async function userPlanSave(userPlan: Partial<IUserPlan>): Promise<string> {
    const result: FetchResult<{ user_plan_save: { uid: string }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { userPlan: {
            uid: userPlan.uid,
            name: userPlan.name,
            plan_id: userPlan.planId,
            access_type: userPlan.accessType,
            final_unit_index: userPlan.finalUnitIndex,
            monthly_video_limit: userPlan.monthlyVideoLimit,
            allows_ongoing_practice: userPlan.allowsOngoingPractice,
            description: userPlan.description,
            one_off: userPlan.oneOff,
            price_id: userPlan.priceId,
            apple_price_id: userPlan.applePriceId,
            google_price_id: userPlan.googlePriceId,
            active_trial: userPlan.freeTrial,
            trial_length: userPlan.trialLength,
            trial_end: userPlan.trialEndDate,
            trial_for_roles: userPlan.trialForRoles,
            type: userPlan.type,
            free: userPlan.free,
            internal: userPlan.internal,
            platforms: userPlan.platforms,
            default: userPlan.default,
            default_for_motivation: userPlan.defaultForMotivation,
            admin_permissions: userPlan.adminPermissions,
            sector: userPlan.sector,
            max_license_count: userPlan.maxLicenseCount,
            learners_allowed: userPlan.learnersAllowed,
            max_groups_per_educator: userPlan.maxGroupsPerEducator,
            recurrence_frequency: userPlan.recurrenceFrequency,
            price: userPlan.price,
        } },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_plan_save?.uid;
}
